
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        totalPages: {
            type: Number,
            default: 1,
        },
        currentPage: {
            type: Number,
            default: 1,
        },
    },
    emits: ['change'],
    setup(props, { emit }) {
        const emitChange = (page: number) => {
            if (page > props.totalPages) return
            if (page < 1) return
            if (page === props.currentPage) return

            emit('change', page)
        }

        return { emitChange }
    },
})
